import { StateCreator } from 'zustand';

export interface TicketSlice {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const ticketSlice: StateCreator<TicketSlice> = (set) => ({
  isOpen: false,
  setIsOpen: (isOpen: boolean) => {
    set(() => ({ isOpen }));
  },
});
